import { useMediaQuery, useTheme } from '@mui/material';
import { FC, ReactNode } from 'react';

import HeaderButton from './components/HeaderButton/HeaderButton';
import HeaderTitle from './components/HeaderTitle/HeaderTitle';
import AtomFlex from '../../../../atoms/AtomFlex';
import AtomGrid from '../../../../atoms/AtomGrid';
import ArrowBackIcon from '../../../../icons/svg/ArrowBackIcon';
import XIcon from '../../../../icons/svg/XIcon';
import { styleConfigs } from '../../../../resources/styleConfigs';
import { modalHeaderTitleType, skillStatusType } from '../../NewModalLayoutComponent';

interface IDefaultModalHeaderProps {
  title?: string | ReactNode;
  centerTitle?: boolean;
  fontSizeTitleHeader?: modalHeaderTitleType;
  activeJobTitle?: boolean;
  jobTitle?: string;
  onBackButton?: VoidFunction;
  skillStatus?: skillStatusType;
  modalClose?: VoidFunction;
  paddingInline?: number | string;
  paddingBlock?: number | string;
  ariaLabels?: {
    backButton?: string;
    closeButton?: string;
  };
}

const DefaultModalHeader: FC<IDefaultModalHeaderProps> = (props) => {
  const {
    title = '',
    centerTitle,
    fontSizeTitleHeader,
    activeJobTitle,
    jobTitle,
    onBackButton,
    skillStatus,
    modalClose,
    paddingInline,
    paddingBlock,
    ariaLabels,
  } = props;
  const theme = useTheme();
  const mdScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AtomFlex
      sx={{
        paddingBlock: paddingBlock ?? styleConfigs.marginPadding.custom20rem,
        paddingInline: paddingInline ?? styleConfigs.marginPadding.custom35rem,
        [theme.breakpoints.down('sm')]: {
          paddingInline: styleConfigs.marginPadding.custom16rem,
        },
      }}
    >
      <AtomGrid
        sx={{
          width: styleConfigs.dimensions.percent100,
          height: styleConfigs.dimensions.percent100,
          display: 'flex',
          alignItems: 'center',
          backgroundColor: theme.palette.background.white,
        }}
      >
        {onBackButton && (
          <HeaderButton aria-label={ariaLabels?.backButton || 'back'} dataTestId="back-button" onClick={onBackButton}>
            <ArrowBackIcon
              data-testid="ArrowBackIcon"
              height={mdScreen ? styleConfigs.dimensions.width30 : styleConfigs.dimensions.width42}
              width={mdScreen ? styleConfigs.dimensions.width30 : styleConfigs.dimensions.width42}
              fill={theme.palette.icons.ebonyClay}
            />
          </HeaderButton>
        )}
        <AtomGrid sx={{ flex: 1, minWidth: 0 }}>
          <HeaderTitle
            title={title}
            centerTitle={centerTitle}
            fontSizeTitleHeader={fontSizeTitleHeader}
            skillStatus={skillStatus}
            activeJobTitle={activeJobTitle}
            jobTitle={jobTitle}
          />
        </AtomGrid>
        {title && modalClose && (
          <HeaderButton
            aria-label={ariaLabels?.closeButton || 'close'}
            dataTestId="close-button"
            onClick={modalClose}
            marginBlock={styleConfigs.marginPadding.custom4rem}
            marginInlineStart={styleConfigs.marginPadding.custom12rem}
            sx={{
              flexShrink: 0,
              position: 'relative',
              zIndex: 1,
              [theme.breakpoints.down('md')]: {
                marginBlock: styleConfigs.marginPadding.empty,
                marginInlineStart: styleConfigs.marginPadding.custom6rem,
                padding: styleConfigs.marginPadding.empty,
              },
            }}
          >
            <XIcon data-testid="CloseIcon" color={theme.palette.icons.ebonyClay} />
          </HeaderButton>
        )}
      </AtomGrid>
    </AtomFlex>
  );
};

export default DefaultModalHeader;
